module.exports = __webpack_public_path__ + "static/media/ljubljana-8.cb47713f.jpg";